import React from "react";
import {connect} from 'react-redux'
import _ from 'lodash'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomWizard from "views/Components/CustomWizard.jsx";

import GeneralInfo from './GeneralInfo'
import IbBankAccounts from './IbBankAccounts'
import IbContactPersons from './IbContactPersons'
import IbTradingAccounts from './IbTradingAccounts'
import IbQuestionnaire from './IbQuestionnaire'
import IbKyc from './IbKyc'
//import RegistrationLink from './RegistrationLink'

//ibs
import {
  ibSave,
  ibsFetch,
  ibFetch
} from 'actions/ibs'
import {
  companiesFetch,
  companyFilter
} from 'actions/companies'
import {
  currenciesFetch,
  currencyFilter
} from 'actions/currencies'
import {
  plaformsFetch,
  plaformFilter
} from 'actions/platforms'

import {
  danger,
  success,
} from 'actions/notification'

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/form";

let steps = [
  {stepName: 'GENERAL INFO', stepId:"1", stepComponent:GeneralInfo},
  {stepName: 'IB CONTACT PERSONS', stepId:"2", stepComponent:IbContactPersons},
  {stepName: 'QUESTIONNAIRE', stepId:"3", stepComponent:IbQuestionnaire},
  {stepName: 'IB BANK ACCOUNTS', stepId:"4", stepComponent:IbBankAccounts},
  {stepName: 'IB TRADING ACCOUNTS', stepId:"5", stepComponent:IbTradingAccounts},
  {stepName: 'SALES & KYC', stepId:"6", stepComponent:IbKyc},
  /*{stepName: 'REGISTRATION LINK', stepId: "7", stepComponent: RegistrationLink}*/
]


class IbWizard extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            ibData: {}
        };
    }


    componentDidMount() {
        this.props.plaformFilter({size: 100})
        this.props.currencyFilter({size: 10000})
        this.props.currenciesFetch();
        this.props.platformsFetch();
        if (this.props.match.params.id) {
            this.props.fetch(this.props.match.params.id)
                .then((e) => {
                    this.setState({
                        ...this.state,
                        ibData: e
                    })

                })
        }

    }

  render() {

      const {ibData} = this.state;

      let dataIB;

      if (this.props.match.params.id) {
          dataIB = steps.map(function (el) {
              var o = Object.assign({}, el);
              o.data = ibData;
              return o;
          });
      }

      return (
          <GridContainer justify="center">
            <GridItem xs={12} sm={10}>
              {!_.isEmpty(ibData) && dataIB &&
              <CustomWizard
                  title="Registrate as an IB"
                  subtitle=""
                  color="warning"
                  match={this.props.match}
                  history={this.props.history}
                  steps={dataIB}/>}
              {_.isEmpty(ibData) && !dataIB &&
              <CustomWizard
                  title="Registrate as an IB"
                  subtitle=""
                  color="warning"
                  match={this.props.match}
                  history={this.props.history}
                  steps={steps}/>}
            </GridItem>
          </GridContainer>
      );

  }
}
const mapStateToProps=(state,props)=>({
  isFetching:state.ibs.isFetching,
  ibs:state.ibs,
  companies: state.companies.list,
  user: state.auth,
  currencies: state.currencies && state.currencies.list,
  platforms: state.platforms && state.platforms.list,
})
const mapDispatchToProps=(dispatch)=>({
  fetch:(id)=>dispatch(ibFetch(id)),
  fetchAll:()=>dispatch(ibsFetch()),
  save:(data)=>dispatch(ibSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  success:(text,sec)=>dispatch(success(text,sec)),
  companiesFetch: () => dispatch(companiesFetch()),
  currenciesFetch: () => dispatch(currenciesFetch()),
  platformsFetch: () => dispatch(plaformsFetch()),
  companyFilter: (filter) => dispatch(companyFilter(filter)),
  currencyFilter: (filter) => dispatch(currencyFilter(filter)),
  plaformFilter: (filter) => dispatch(plaformFilter(filter))
})
export default withStyles({...styles})(connect(mapStateToProps,mapDispatchToProps)(IbWizard));



// WEBPACK FOOTER //
// ./src/views/Ibs/Wizard/IbWizard.jsx